module.exports = __webpack_public_path__ + "img/help-ot7.80ff0fbd.png";